import { Component, Input } from "@angular/core";
import { MatAccordion, MatExpansionModule, MatExpansionPanel } from "@angular/material/expansion";

@Component({
    selector: "mit-forbrug-info-box",
    standalone: true,
    imports: [MatAccordion, MatExpansionModule, MatExpansionPanel],
    templateUrl: "./mit-forbrug-info-box.component.html",
    styleUrl: "./mit-forbrug-info-box.component.scss"
})
export class MitForbrugInfoBoxComponent {
    @Input()
    public infoBox: {
        infoboksOverskrift: string;
        infoboksBeskrivelse: string;
        infoboksFarveStatus?: string;
    };
    public panelOpenState = false;

    public getColorStatus(): string {
        const colorStatus = this.infoBox.infoboksFarveStatus;
        if (colorStatus === "Grøn") {
            return "green";
        } else if (colorStatus === "Rød") {
            return "red";
        } else {
            return "";
        }
    }
}
